import { NavLink } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { ReactComponent as LogoHome } from '../../../assets/svg/search-mobile.svg';
import { ReactComponent as LogoMolecule } from '../../../assets/svg/molecule.svg';
import { ReactComponent as LogoSymptome } from '../../../assets/svg/symptome.svg';
import { ReactComponent as LogoEntrainemnt } from '../../../assets/svg/entrainement.svg';
import { ReactComponent as LogoInformations } from '../../../assets/svg/information.svg';
import styled from "styled-components";
import labels from '../../../_translations/locals.json';
import store from "../../../_services/store";
import { COLORS } from "../../../constants";
import { useWindowResize } from "../../../_hooks/use-window-resize";
import { observer } from "mobx-react";

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  svg {
    &.active {
    fill: ${COLORS.WHITE};
  }
    width: 30px;
    height: 30px;
  }
`;

const NavbarText = styled.span`
  color: ${COLORS.DARK};
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
`;

const LinkElem = styled(NavLink)`
  &.active {
    color: ${props => props.theme.orange};
    border-radius: 10px;
    color: ${COLORS.PRIMARY};
    ${TitleContainer}{
      ${NavbarText}{
        color: ${COLORS.PRIMARY};
        text-decoration: underline;
        text-underline-offset: 4px;
        text-decoration-thickness: 3px;
      }
    }
  }
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  color: ${COLORS.DARK};
  background: transparent;
`;

const Container = styled.div`
  display: flex;
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  margin: 0;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px 20px 0px 0px;
  background: #FFF;
  box-shadow: 0px 4px 13.8px 0px rgba(0, 0, 0, 0.25);
  z-index: 1000;
`;

const NavbarMobile = observer(() => {
  const { width } = useWindowResize();
  const minWidth = (width - 10) / 5;
  const menu = (
    <>
      <LinkElem
        key={"MOLECULES"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none", padding: 0, minWidth: `${minWidth}px` }}
        to={ROUTES.MOLECULES()}
      >
        <TitleContainer>
          <LogoMolecule fill={COLORS.DARK} width={30} height={30} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.accueil}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"SYMPTOMES"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none", padding: 0, minWidth: `${minWidth}px` }}
        to={ROUTES.SYMPTOMS()}
      >
        <TitleContainer>
          <LogoSymptome fill={COLORS.DARK} width={30} height={30} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab1}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"HOME"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ minWidth: `${minWidth}px`, minHeight: '45px', padding: 0, display: 'flex' }}
        to={ROUTES.HOME()}
      >
        <LogoHome style={{ textDecoration: "none", padding: 0, position: 'relative', bottom: '30px', width: '60px', margin: 'auto' }} fill={COLORS.DARK} />
      </LinkElem >

      <LinkElem
        key={"ENTRAINEMENT"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none", padding: 0, minWidth: `${minWidth}px` }}
        to={ROUTES.TRAINING()}
      >
        <TitleContainer>
          <LogoEntrainemnt fill={COLORS.DARK} width={30} height={30} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab2}</NavbarText>
        </TitleContainer>
      </LinkElem >

      <LinkElem
        key={"INFORMATIONS"}
        className={({ isActive }) => (isActive ? 'active' : 'inactive')}
        style={{ textDecoration: "none", padding: 0, minWidth: `${minWidth}px` }}
        to={ROUTES.INFORMATIONS()}
      >
        <TitleContainer>
          <LogoInformations fill={COLORS.DARK} width={30} height={30} />
          <NavbarText>{labels[store.currentLanguage].tabbar.labels.tab3}</NavbarText>
        </TitleContainer>
      </LinkElem >
    </>
  );

  return (
    <Container>
      {menu}
    </Container>
  )
})

export default NavbarMobile;